import { Link, useLocation } from 'react-router-dom'

import styles from './AppShell.module.css'

/**
 * The catch-all route.
 *
 * Reachable in normal use — a deep link the user bookmarked to a track they
 * have since deleted lands here. So it names the path rather than saying only
 * "not found", and offers a way back rather than leaving a dead end.
 */
export function NotFound() {
  const { pathname } = useLocation()

  return (
    <div className={styles['notice']}>
      <h1>No such screen</h1>
      <p>
        Nothing lives at <code>{pathname}</code>. If you followed a bookmark, the thing it
        pointed at may have been deleted.
      </p>
      <Link to="/">Back to home</Link>
    </div>
  )
}
